import React, {FC} from "react";
import useTranslate from "../../modules/core/languages/hooks/useTranslate";
import HotelDetail from "../../modules/hotels/types/HotelDetail";
import useCustomerContext from "../../modules/customers/hooks/useCustomerContext";

export interface HotelCancellationPolicyCardProps {
    eventHotelTranslation: HotelDetail;
}

const HotelCancellationPolicyCard: FC<HotelCancellationPolicyCardProps> = ({
    eventHotelTranslation,
}) => {
    const t = useTranslate();
    const {languageCode} = useCustomerContext();

    return (
        <div className="listingSection__wrap !mt-5">
            <h2 className="text-2xl font-semibold">{t("hotelDetail.cancellationPolicy")}</h2>
            <div className="text-neutral-6000 dark:text-neutral-300">
                <span dangerouslySetInnerHTML={{__html: eventHotelTranslation.trCancellationPolicy[languageCode]}}/>
            </div>
        </div>
    );
};

export default HotelCancellationPolicyCard;
